import * as React from "react";
import type { SVGProps } from "react";
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M21.74 18.05 13.77 4.02c-.77-1.36-2.77-1.36-3.55 0L2.26 18.05C1.51 19.37 2.49 21 4.03 21h15.94c1.55 0 2.52-1.63 1.77-2.95M11.24 8c0-.41.34-.74.76-.74s.76.33.76.74v5.8c0 .41-.34.74-.76.74a.75.75 0 0 1-.76-.74zm.76 9.77a.997.997 0 0 1-1.01-.99c0-.55.45-.99 1.01-.99s1.01.44 1.01.99-.45.99-1.01.99"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWarning;
